import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule, NgFor } from '@angular/common';

@Component({
  selector: 'app-rejected-orders',
  standalone: true,
  imports: [CommonModule, NgFor],
  templateUrl: './rejected-orders.component.html',
  styleUrls: ['./rejected-orders.component.css']
})
export class RejectedOrdersComponent {
  @Input() orders: any[] = [];
  @Output() orderUpdated = new EventEmitter<any>();

  /**
   * Emits an event to update the order's status to 'approval_waiting'.
   * This allows a rejected order to be re-submitted for approval.
   * @param order The order to be updated.
   */
  requestApproval(order: any): void {
    // Prevent multiple requests for the same order
    if (order.status !== 'approval_waiting') {
      const updatedData = {
        orderId: order.id,
        status: 'approval_waiting'
      };
      // Emit the update event to the parent component
      this.orderUpdated.emit(updatedData);
    }
  }
}
